import React from 'react';
import { Link } from 'react-router-dom';
import { pillarNav, socialLinks } from '../data/navigation';
type FooterProps = {
  activePillar: string;
};
export function Footer({
  activePillar
}: FooterProps) {
  return <footer className="w-full border-t border-accent-deep/50 bg-ink pb-32 pt-16 lg:pb-16" data-id="element-56" data-mp="32ovuyo49khgz">
      <div className="mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-57" data-mp="36oo5359b2vog">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between" data-id="element-58" data-mp="3uf0lz5mj42r6">
          <div data-id="element-59" data-mp="38quwwb59nq4">
            <p className="text-sm font-extrabold uppercase tracking-label text-bone" data-id="element-60" data-mp="3990wknlzgb8">CreceElite</p>
            <p className="mt-4 text-[13px] text-ash" data-id="element-61" data-mp="3levhb38pzigp">
              “Descubre tu propósito. Vive en abundancia.”
            </p>
          </div>

          <nav aria-label="Pilares" className="lg:pt-1" data-id="element-62" data-mp="3qbvnrf9hen8c">
            <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-63" data-mp="29ynm5mvmb9f2">
              {pillarNav.map(link => {
              const isActive = link.label.toLowerCase() === activePillar;
              return <li key={link.label} data-id="element-64" data-mp="3l8qvw2zluhqx">
                    <Link to={link.to} aria-current={isActive ? 'page' : undefined} className={`text-[11px] font-semibold uppercase tracking-label transition-colors duration-200 ease-elite hover:text-accent ${isActive ? 'text-accent' : 'text-ash'}`} data-id="element-65" data-mp="3l9shv2i5sonf">
                      {link.label}
                    </Link>
                  </li>;
            })}
            </ul>
          </nav>

          <nav aria-label="Redes sociales" className="lg:pt-1" data-id="element-66" data-mp="hsk3ismn46xg">
            <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-67" data-mp="hs1vyzuj26a8">
              {socialLinks.map(social => <li key={social} data-id="element-68" data-mp="cvtng5au5bc1">
                  <a href="#" className="text-[11px] font-semibold uppercase tracking-label text-ash transition-colors duration-200 ease-elite hover:text-accent" data-id="element-69" data-mp="qt049uc00zym">
                    {social}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-14 text-[11px] text-ash/40" data-id="element-70" data-mp="yuh6sd0wlt2u">
          © {new Date().getFullYear()} CreceElite. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}